import { useEffect } from "react"
import { Route, Routes, useLocation } from "react-router-dom"
import useLocalStorageState from "use-local-storage-state"
import { AppLayout } from "../layouts/AppLayout"
import { Forbidden } from "../Pages/errors/Forbidden"
import { NotFound } from "../Pages/errors/NotFound"

// Pages
import { Contacts } from "../Pages/Contacts/Contacts.jsx"
import { Dashboard } from "../Pages/dashboard/Dashboard"
import { Enquiry } from "../Pages/Company/Enquiry"
import { Master } from "../Pages/settings/masters/Master.jsx"
import { Designation } from "../Pages/settings/masters/Designation/Designation.jsx"
import { Department } from "../Pages/settings/masters/Department/Department.jsx"
import { Users } from "../Pages/users/Users"
import { Settings } from "../Pages/settings/Settings.jsx"
import { CreateShift } from "../Pages/settings/masters/shift/CreateShift.jsx"
import { LeadSoucre } from "../Pages/settings/masters/leadSource/LeadSource.jsx"
import { Protected } from "../Protected"
import { Companies } from "../Pages/Company/Companies"
import { ChangePassword } from "../Pages/changePassword/ChangePassword"
import { CreatePassword } from "../Auth/CreatePassword"
import { ProductServices } from "../Pages/settings/masters/productService/ProductServices.jsx"
import { CreatePipelinePage } from "../Pages/PipelineComponents/CreatePipelinePage"
import { EditPipelinePage } from "../Pages/PipelineComponents/EditPipelinePage"
import { Preferences } from "../Pages/settings/Preferences/Preferences.jsx"
import { NotificationTemplates } from "../Pages/settings/Preferences/NotificationTemplates.jsx"
import { Integrations } from "../Pages/settings/Integrations/Integrations.jsx"
import { MSG } from "../Pages/settings/Integrations/MSG.jsx"
import { EmailIntegration } from "../Pages/settings/Integrations/EmailIntegrations.jsx"
import CustomFieldManager from "./../Pages/CustomFields/components/CustomFieldManager"
import { EmailCampaingning } from "../Pages/campaigningComponents/EmailCampaingning"
import { Deals } from "../Pages/deals/Deals"
import { WhatsAppCampainging } from "../Pages/campaigningComponents/WhatsAppCampainging"
import { AddCurrency } from "../Pages/settings/masters/Currency/Currency.jsx"
import { CreateQuotation } from "./../Pages/Quotation/CreateQuotation"
import { Quotations } from "./../Pages/Quotation/Quotations"
import Prefix from "../Pages/settings/Preferences/Prefix.jsx"
import { DetailsQuotation } from "../Pages/Quotation/DetailsQuotation"
import { PurchaseOrder } from "./../Pages/PurchaseOrder/PurchaseOrder"
import { CreatePurchaseOrder } from "./../Pages/PurchaseOrder/CreatePurchaseOrder"
import { CreateSalesOrder } from "../Pages/SalesOrder/CreateSalesOrder"
import { PurchaseDetail } from "../Pages/PurchaseOrder/PurchaseDetail"
import TabIndex from "../Pages/SalesOrder/TabIndex"
import { CreateInvoiceOrder } from "./../Pages/Invoice/CreateInvoiceOrder"
import { CreateRecurringOrder } from "./../Pages/RecurringInvoices/CreateRecurringOrder"
import { Templates } from "../Pages/settings/masters/templates/Templates.jsx"
import { Chart } from "../Pages/settings/masters/charts/Chart.jsx"
import { CreatePayment } from "./../Pages/payment/CreatePayment"
import CalendarContainer from "./../Pages/Calendar/CalenderContainer"
import Projects from "./../Pages/project/Project"
import { Report } from "./../Pages/report/Report"
import { QuotationDetails } from "./../Pages/Quotation/QuotationDetails"
import { EditQuotation } from "../Pages/Quotation/EditQuotation.jsx"
import { ProjectDashboard } from "../Pages/dashboard/ProjectDashboard"
import EmailSettings from "../Pages/dashboard/inbox/EmailSettings"
import EmailSmtpIntegration from "../Pages/dashboard/inbox/EmailSmtpIntegration"
import { EditInvoice } from "../Pages/Invoice/EditInvoice"
import SMSTemplate from "../Pages/settings/Preferences/SMSTemplate.jsx"
import Announcement from "../Pages/settings/Preferences/Announcement.jsx"
import KnowledgeBase from "../Pages/settings/Preferences/KnowledgeBase.jsx"
import LeadsVisibility from "../Pages/settings/Preferences/LeadsVisibility.jsx"
import SetTarget from "../Pages/settings/Preferences/SetTarget.jsx"
import WhatsappAPI from "../Pages/settings/Preferences/WhatsappAPI.jsx"
import TermsAndConditions from "../Pages/settings/Preferences/TermsAndConditions.jsx"
import SMSCampaigning from "../Pages/campaigningComponents/SMSCampaigning"
import { Subscription } from "../CommonComponents/Subscription"
import { Summary } from "../CommonComponents/Summary"
import { RolePermission } from "../Pages/settings/roleManagement/RolePermission.jsx"
import WorkFlowTable from "../Pages/WorkFlow/WorkFlowTable"
import WorkFlow from "../Pages/WorkFlow/WorkFlow"
import { Setup } from "./../Profile/Setup"
import { SetupCompanyDetails } from "./../Profile/SetupCompanyDetails"
import { SetupGst } from "./../Profile/SetupGst"
import { SetupUserDetails } from "./../Profile/SetupUserDetails"
import { PaymentSubscriptionDetails } from "./../Pages/subscriptionPayment/PaymentSubscriptionDetails"
import SubscriptionDetails from "./../Pages/subscriptionPayment/SubscriptionDetails"
import { EditSalesOrder } from "../Pages/SalesOrder/EditSalesOrder"
import { ImportData } from "./../CommonComponents/Import/ImportData"
import BrowserCall from "./../Pages/ivr/BrowserCall"
// @ts-ignore
import Leads from "../Pages/Leads/Leads.jsx"
import EmailContainer from "./../Pages/dashboard/inbox/EmailContainer"
import { IntegrationDetail } from "../Pages/settings/Integrations/IntegrationDetail.jsx"
import RoundRobin from "./../Pages/RoundRobin/RoundRobin"
import TrackingMap from "../Pages/gps/Tracking.jsx"
import { RoleManagement } from "../Pages/settings/roleManagement/RoleManagement.jsx"
import { GSTCalculator } from "../Pages/toolsComponent/GSTCalculator.jsx"
import FacebookLead from "./../Pages/settings/Integrations/Facebook/FacebookLead"
import { DuplicatePipelinePage } from "../Pages/PipelineComponents/DuplicatePipelinePage.jsx"
import { LeadsDetails } from "../Pages/detailPage/leads/LeadsDetails.jsx"
import { DealDetails } from "../Pages/deals/DealDetails.jsx"
import { ContactDetails } from "../Pages/detailPage/Contacts/ContactDetails.jsx"
import { CompanyDetails } from "../Pages/detailPage/Company/CompanyDetails.jsx"

import DocumentManager from './../Pages/DocumentManager';

const excludedPaths = ["/login", "/register", "/", "/forgot-password", "/403"]

const setupChildren = [
  { path: "companyDetails", element: <SetupCompanyDetails />, index: true },
  { path: "gst", element: <SetupGst />, index: true },
  { path: "userDetails", element: <SetupUserDetails />, index: true },
]

const settingsChildren = [
  { path: "masters", element: <Master /> },
  { path: "integration/:id", element: <IntegrationDetail /> },
  { path: "users", element: <Users /> },
  { path: "roleManagement", element: <RoleManagement /> },
  { path: "preference", element: <Preferences /> },
  { path: "integration", element: <Integrations /> },
]

const preferencesChildren = [
  { path: "form", element: <CustomFieldManager /> },
  { path: "notificationTemplates", element: <NotificationTemplates /> },
  { path: "sms-templates", element: <SMSTemplate /> },
  { path: "announcement", element: <Announcement /> },
  { path: "knowledge-base", element: <KnowledgeBase /> },
  { path: "leads-visibility", element: <LeadsVisibility /> },
  { path: "set-target", element: <SetTarget /> },
  { path: "whatsapp-api", element: <WhatsappAPI /> },
  { path: "terms-conditions", element: <TermsAndConditions /> },
  { path: "prefix", element: <Prefix /> },
]

const protectedRoutes = [
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/enquiry", element: <Enquiry /> },
  { path: "/master", element: <Master /> },
  { path: "/company", element: <Companies /> },
  { path: "/companyDetails", element: <CompanyDetails /> },
  { path: "/quotations", element: <Quotations /> },
  { path: "/workflow", element: <WorkFlowTable /> },
  { path: "/createworkflow", element: <WorkFlow /> },
  { path: "/editworkflow/:paramId", element: <WorkFlow /> },
  { path: "/rolePermissions", element: <RolePermission /> },
  { path: "/paymentdetails", element: <PaymentSubscriptionDetails /> },
  { path: "/subscriptiondetails", element: <SubscriptionDetails /> },
  { path: "/editsalesorder/:paramId", element: <EditSalesOrder /> },
  { path: "/integration/twillo", element: <BrowserCall /> },
  { path: "/roundrobin", element: <RoundRobin /> },
  { path: "/tracking", element: <TrackingMap /> },
  { path: "/facebook_lead", element: <FacebookLead /> },
  {
    path: "/setup",
    element: <Setup />,
    children: setupChildren,
  },
  { path: "/email-settings", element: <EmailSettings /> },
  { path: "/importdata", element: <ImportData /> },
  { path: "/inbox", element: <EmailContainer /> },
  { path: "/createquotation", element: <CreateQuotation /> },
  { path: "/detailquotation/:paramId", element: <DetailsQuotation /> },
  { path: "/editquotation/:paramId", element: <EditQuotation /> },
  { path: "/quotationdetail/:quoteID/:customerId/:quotationNumber", element: <QuotationDetails /> },
  { path: "/purchaseorder", element: <PurchaseOrder /> },
  { path: "/createpurchaseorder/:id", element: <CreatePurchaseOrder /> },
  { path: "/calender", element: <CalendarContainer /> },
  { path: "/projects", element: <Projects /> },
  { path: "/reports", element: <Report /> },
  { path: "/salesorder", element: <TabIndex /> },
  { path: "/salesorder/:salesId/:customerId/:saleNumber", element: <TabIndex /> },
  { path: "/createSalesOrder", element: <CreateSalesOrder /> },
  { path: "/purchaseDetail/:id/:module", element: <PurchaseDetail /> },
  { path: "/templates", element: <Templates /> },
  { path: "/chartOfAccounts", element: <Chart /> },
  { path: "/createInvoiceOrder", element: <CreateInvoiceOrder /> },
  { path: "/cloneInvoice/:cloneId", element: <EditInvoice /> },
  { path: "/createpayment", element: <CreatePayment /> },
  { path: "/createRecurringOrder", element: <CreateRecurringOrder /> },
  {
    path: "/settings",
    element: <Settings />,
    children: settingsChildren,
  },
  { path: "/contacts", element: <Contacts /> },
  { path: "/contactDetails", element: <ContactDetails /> },

  { path: "/leads", element: <Leads /> },
  { path: "/leadDetails", element: <LeadsDetails /> },

  { path: "/deals", element: <Deals /> },
  { path: "/dealDetails", element: <DealDetails /> },

  { path: "/createpipeline", element: <CreatePipelinePage /> },
  { path: "/editpipeline/:encodedId", element: <EditPipelinePage /> },
  { path: "/duplicatepipeline/:encodedId", element: <DuplicatePipelinePage /> },

  { path: "/integration/msg91", element: <MSG /> },
  { path: "/integration/email", element: <EmailIntegration /> },
  { path: "/department", element: <Department /> },
  { path: "/product", element: <ProductServices /> },
  { path: "/designation", element: <Designation /> },
  { path: "/shift", element: <CreateShift /> },
  { path: "/currency", element: <AddCurrency /> },
  { path: "/enquirySource", element: <LeadSoucre /> },
  { path: "/changePassword", element: <ChangePassword /> },
  { path: "/documentManager", element: <DocumentManager /> },
  {
    path: "/preferences",
    children: preferencesChildren,
  },

  { path: "/email", element: <EmailCampaingning /> },
  { path: "/whatsapp", element: <WhatsAppCampainging /> },
  { path: "/sms", element: <SMSCampaigning /> },
  { path: "/ProjectDashboard", element: <ProjectDashboard /> },
  {
    path: "/tools",
    children: [{ path: "gstCalculator", element: <GSTCalculator /> }],
  },
]

const renderRoutes = (routes) =>
  routes.map(({ path, element, children, index }) =>
    children ? (
      <Route key={path} path={path} element={element} index={index}>
        {renderRoutes(children)}
      </Route>
    ) : (
      <Route key={path} path={path} element={element} index={index} />
    )
  )

export const Routers = () => {
  const location = useLocation()
  const [, setLastPath] = useLocalStorageState("lastPath", "/dashboard")

  useEffect(() => {
    if (!excludedPaths.includes(location.pathname) && !location.pathname.startsWith("/create-password/")) {
      setLastPath(location.pathname)
    }
  }, [location.pathname, setLastPath])

  return (
    <Routes>
      <Route path="/planSummary" element={<Summary />} />
      {/* Outside Protected: invite links must not hit the catch-all session gate */}
      <Route
        path="/create-password/:org_code/:token/:user_id?"
        element={<CreatePassword />}
      />
      <Route element={<Protected />}>
        <Route element={<AppLayout />}>
          {renderRoutes(protectedRoutes)}
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>
      <Route path="/plans" element={<Subscription />} />
    </Routes>
  )
}